import { useState, useEffect, useRef, useCallback } from "react";
import { X, ChevronLeft, ChevronRight, ZoomIn, Filter, Images } from "lucide-react";

const galleryImages = [
  // Clients — Truck key handover ceremonies
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/mo19w2tq_WhatsApp%20Image%202026-03-03%20at%206.07.29%20PM.jpeg",
    thumb: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/mo19w2tq_WhatsApp%20Image%202026-03-03%20at%206.07.29%20PM.jpeg",
    alt: "New Tata truck key handover ceremony",
    category: "Clients",
    title: "New Fleet Addition - Key Handover",
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/5xxtb7rw_WhatsApp%20Image%202026-03-03%20at%206.07.30%20PM.jpeg",
    thumb: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/5xxtb7rw_WhatsApp%20Image%202026-03-03%20at%206.07.30%20PM.jpeg",
    alt: "Tata truck key handover with client",
    category: "Clients",
    title: "Fleet Handover Ceremony",
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1606836591695-4d58a73eba1e?crop=entropy&cs=srgb&fm=webp&w=800&q=75",
    thumb: "https://images.unsplash.com/photo-1606836591695-4d58a73eba1e?crop=entropy&cs=srgb&fm=webp&w=400&q=60",
    alt: "Business professionals discussing logistics plans",
    category: "Clients",
    title: "Logistics Planning with Partners",
  },

  // Loading — Crane & cargo loading operations
  {
    id: 5,
    src: "https://image2url.com/r2/default/images/1772541146689-e2f68bb3-749f-4b6c-bb0d-0460a61ae133.jpeg",
    thumb: "https://image2url.com/r2/default/images/1772541146689-e2f68bb3-749f-4b6c-bb0d-0460a61ae133.jpeg",
    alt: "Forklift loading cargo into truck",
    category: "Loading",
    title: "Forklift Loading Operations",
  },
  {
    id: 6,
    src: "https://image2url.com/r2/default/images/1772541215837-8a1f4ed6-9665-4115-b7f7-515aa35b022f.jpeg",
    thumb: "https://image2url.com/r2/default/images/1772541215837-8a1f4ed6-9665-4115-b7f7-515aa35b022f.jpeg",
    alt: "Loading dock operations",
    category: "Loading",
    title: "Dock Loading & Unloading",
  },
  {
    id: 7,
    src: "https://image2url.com/r2/default/images/1772541244763-22ae0b5d-53f0-4ab8-8148-16cce1ab2b72.jpeg",
    thumb: "https://image2url.com/r2/default/images/1772541244763-22ae0b5d-53f0-4ab8-8148-16cce1ab2b72.jpeg",
    alt: "Warehouse cargo handling",
    category: "Loading",
    title: "Cargo Handling at Warehouse",
  },
  {
    id: 19,
    src: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/4fnk9ztd_WhatsApp%20Image%202026-03-03%20at%207.04.39%20PM.jpeg",
    thumb: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/4fnk9ztd_WhatsApp%20Image%202026-03-03%20at%207.04.39%20PM.jpeg",
    alt: "STS gantry crane loading containers onto cargo ship",
    category: "Loading",
    title: "Gantry Crane Container Loading",
  },
  {
    id: 20,
    src: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/4qjqyya9_IMG_6874.jpg.jpeg",
    thumb: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/4qjqyya9_IMG_6874.jpg.jpeg",
    alt: "He Run Shipping vessel being loaded by port crane",
    category: "Loading",
    title: "Ship Loading at Port",
  },

  // Fleet — Trucks and transport vehicles
  {
    id: 8,
    src: "https://image2url.com/r2/default/images/1772541269916-2a54f37c-3db3-46aa-b83c-67611a76e935.jpeg",
    thumb: "https://image2url.com/r2/default/images/1772541269916-2a54f37c-3db3-46aa-b83c-67611a76e935.jpeg",
    alt: "Cargo truck on highway",
    category: "Fleet",
    title: "Heavy Cargo Transport",
  },
  {
    id: 9,
    src: "https://image2url.com/r2/default/images/1772541300034-e2e53633-7a2a-4dd2-8e30-58763e16e20d.jpeg",
    thumb: "https://image2url.com/r2/default/images/1772541300034-e2e53633-7a2a-4dd2-8e30-58763e16e20d.jpeg",
    alt: "Transport truck fleet",
    category: "Fleet",
    title: "Highway Freight Transport",
  },
  {
    id: 10,
    src: "https://image2url.com/r2/default/images/1772541322850-f12ed930-da59-487a-8b9a-a3ecafa6469a.jpeg",
    thumb: "https://image2url.com/r2/default/images/1772541322850-f12ed930-da59-487a-8b9a-a3ecafa6469a.jpeg",
    alt: "Commercial cargo truck",
    category: "Fleet",
    title: "Commercial Fleet Vehicle",
  },
  {
    id: 11,
    src: "https://image2url.com/r2/default/images/1772541349214-1d2d80b0-2564-4fee-b14b-4feb40326d7c.jpeg",
    thumb: "https://image2url.com/r2/default/images/1772541349214-1d2d80b0-2564-4fee-b14b-4feb40326d7c.jpeg",
    alt: "Delivery truck on road",
    category: "Fleet",
    title: "Nationwide Delivery Fleet",
  },

  // Warehouse — Storage and container yards
  {
    id: 13,
    src: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=webp&w=800&q=75",
    thumb: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=webp&w=400&q=60",
    alt: "Warehouse with organized shelving",
    category: "Warehouse",
    title: "Organized Storage Facility",
  },
  {
    id: 14,
    src: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=webp&w=800&q=75",
    thumb: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=webp&w=400&q=60",
    alt: "Distribution center operations",
    category: "Warehouse",
    title: "Distribution Center Operations",
  },
  {
    id: 23,
    src: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/kn9n4w2x_WhatsApp%20Image%202026-03-03%20at%207.04.43%20PM.jpeg",
    thumb: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/kn9n4w2x_WhatsApp%20Image%202026-03-03%20at%207.04.43%20PM.jpeg",
    alt: "MSC shipping containers stacked at port yard with gantry cranes",
    category: "Warehouse",
    title: "Container Yard Operations",
  },

  // Transportation — Ships, port operations, project cargo
  {
    id: 15,
    src: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/8xd527wc_1772541397254-b8f8db60-0460-4fd3-8200-1952ba3451d8.jpg",
    thumb: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/8xd527wc_1772541397254-b8f8db60-0460-4fd3-8200-1952ba3451d8.jpg",
    alt: "Heavy cargo loaded on flatbed trailer",
    category: "Transportation",
    title: "Project Cargo Transport",
  },
  {
    id: 21,
    src: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/nrvs11am_IMG_6871.jpg.jpeg",
    thumb: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/nrvs11am_IMG_6871.jpg.jpeg",
    alt: "FOLK Dammam container ship docked at port with gantry cranes",
    category: "Transportation",
    title: "Container Ship at Port",
  },
  {
    id: 22,
    src: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/41qhku9k_WhatsApp%20Image%202026-03-03%20at%207.04.40%20PM.jpeg",
    thumb: "https://customer-assets.emergentagent.com/job_logistics-live-build/artifacts/41qhku9k_WhatsApp%20Image%202026-03-03%20at%207.04.40%20PM.jpeg",
    alt: "Port yard with MSC Abidjan ship and gantry cranes",
    category: "Transportation",
    title: "Port Yard Operations",
  },
];

const categories = ["All", "Clients", "Loading", "Fleet", "Warehouse", "Transportation"];

const categoryColors = {
  All: "from-[#0F172A] to-[#334155]",
  Clients: "from-[#0EA5E9] to-[#0284C7]",
  Loading: "from-[#F97316] to-[#EA580C]",
  Fleet: "from-[#0F172A] to-[#1E293B]",
  Warehouse: "from-[#059669] to-[#047857]",
  Transportation: "from-[#7C3AED] to-[#6D28D9]",
};

function LazyImage({ src, alt, className, onClick }) {
  const [loaded, setLoaded] = useState(false);
  const [inView, setInView] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    if (imgRef.current) observer.observe(imgRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={imgRef} className={`relative overflow-hidden ${className}`} onClick={onClick}>
      {!loaded && (
        <div className="absolute inset-0 bg-slate-200 animate-pulse" />
      )}
      {inView && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          className={`w-full h-full object-cover transition-all duration-700 ${
            loaded ? "opacity-100 scale-100" : "opacity-0 scale-105"
          }`}
        />
      )}
    </div>
  );
}

function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    },
    [onClose, onPrev, onNext]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [handleKeyDown]);

  const image = images[currentIndex];

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      data-testid="lightbox-overlay"
    >
      <div
        className="absolute inset-0 bg-[#0F172A]/95 backdrop-blur-sm animate-fade-in"
        onClick={onClose}
      />

      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-10 p-2.5 bg-white/10 hover:bg-white/20 rounded-full text-white transition-all duration-200 hover:rotate-90"
        data-testid="lightbox-close"
      >
        <X size={22} strokeWidth={1.5} />
      </button>

      <div className="absolute top-5 left-1/2 -translate-x-1/2 z-10 text-white/70 text-sm font-semibold font-['Barlow_Condensed'] tracking-wider">
        {currentIndex + 1} / {images.length}
      </div>

      {images.length > 1 && (
        <>
          <button
            onClick={(e) => { e.stopPropagation(); onPrev(); }}
            className="absolute left-3 md:left-6 z-10 p-2.5 bg-white/10 hover:bg-white/20 rounded-full text-white transition-all duration-200 hover:scale-110"
            data-testid="lightbox-prev"
          >
            <ChevronLeft size={24} strokeWidth={1.5} />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onNext(); }}
            className="absolute right-3 md:right-6 z-10 p-2.5 bg-white/10 hover:bg-white/20 rounded-full text-white transition-all duration-200 hover:scale-110"
            data-testid="lightbox-next"
          >
            <ChevronRight size={24} strokeWidth={1.5} />
          </button>
        </>
      )}

      <div className="relative z-10 max-w-[90vw] max-h-[85vh] animate-fade-in-up">
        <img
          src={image.src}
          alt={image.alt}
          className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
          data-testid="lightbox-image"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-4 md:p-6 rounded-b-lg">
          <h3 className="text-white font-['Barlow_Condensed'] font-bold text-lg md:text-xl">
            {image.title}
          </h3>
          <span className="inline-block mt-1 text-xs font-semibold text-white/70 bg-white/15 px-2.5 py-1 rounded-full">
            {image.category}
          </span>
        </div>
      </div>
    </div>
  );
}

export default function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [animateCards, setAnimateCards] = useState(true);

  const filtered =
    activeCategory === "All"
      ? galleryImages
      : galleryImages.filter((img) => img.category === activeCategory);

  const handleCategoryChange = (cat) => {
    setAnimateCards(false);
    setActiveCategory(cat);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setAnimateCards(true));
    });
  };

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const prevImage = () =>
    setLightboxIndex((prev) => (prev === 0 ? filtered.length - 1 : prev - 1));

  const nextImage = () =>
    setLightboxIndex((prev) => (prev === filtered.length - 1 ? 0 : prev + 1));

  const getCategoryCount = (cat) =>
    cat === "All"
      ? galleryImages.length
      : galleryImages.filter((img) => img.category === cat).length;

  return (
    <div>
      {/* Page Header */}
      <section className="page-header py-20 md:py-28" data-testid="gallery-page-header">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-6">
            <Images size={16} strokeWidth={1.5} className="text-[#F97316]" />
            <span className="text-white/80 text-sm font-medium">Our Visual Journey</span>
          </div>
          <h1
            className="font-['Barlow_Condensed'] font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-4"
            data-testid="gallery-heading"
          >
            Photo Gallery
          </h1>
          <p className="text-slate-300 text-base md:text-lg max-w-2xl mx-auto">
            A glimpse into our operations, team, and the dedication we bring to every shipment
          </p>
        </div>
      </section>

      {/* Category Filters */}
      <section className="py-8 bg-white border-b border-slate-100 sticky top-[64px] md:top-[80px] z-40 backdrop-blur-md bg-white/90" data-testid="gallery-filters">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 mb-4 text-sm text-slate-500">
            <Filter size={15} strokeWidth={1.5} />
            <span className="font-medium">Filter by Category</span>
          </div>
          <div className="flex flex-wrap gap-2 md:gap-3">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => handleCategoryChange(cat)}
                data-testid={`filter-${cat.toLowerCase()}`}
                className={`group relative px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300 ${
                  activeCategory === cat
                    ? `bg-gradient-to-r ${categoryColors[cat]} text-white shadow-md`
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200 hover:text-[#0F172A]"
                }`}
              >
                {cat}
                <span
                  className={`ml-2 text-xs px-1.5 py-0.5 rounded-full ${
                    activeCategory === cat
                      ? "bg-white/20 text-white"
                      : "bg-slate-200 text-slate-500 group-hover:bg-slate-300"
                  }`}
                >
                  {getCategoryCount(cat)}
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 md:py-20 bg-[#F8FAFC]" data-testid="gallery-grid-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-8">
            <p className="text-slate-500 text-sm">
              Showing <span className="font-bold text-[#0F172A]">{filtered.length}</span>{" "}
              {filtered.length === 1 ? "photo" : "photos"}
              {activeCategory !== "All" && (
                <>
                  {" "}in{" "}
                  <span className="font-bold text-[#F97316]">{activeCategory}</span>
                </>
              )}
            </p>
          </div>

          <div className="gallery-grid" data-testid="gallery-image-grid">
            {filtered.map((image, index) => (
              <div
                key={image.id}
                className={`gallery-item ${animateCards ? "gallery-item-visible" : ""}`}
                style={{ animationDelay: `${index * 0.06}s` }}
                data-testid={`gallery-item-${image.id}`}
              >
                <div
                  className="gallery-card group cursor-pointer"
                  onClick={() => openLightbox(index)}
                >
                  <LazyImage
                    src={image.thumb}
                    alt={image.alt}
                    className="w-full h-full"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/90 via-[#0F172A]/30 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-400 flex flex-col justify-end p-4 md:p-5">
                    <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-400">
                      <h3 className="text-white font-['Barlow_Condensed'] font-bold text-base md:text-lg leading-tight">
                        {image.title}
                      </h3>
                      <span className="inline-block mt-2 text-xs font-semibold text-white/80 bg-white/15 backdrop-blur-sm px-2.5 py-1 rounded-full">
                        {image.category}
                      </span>
                    </div>
                    <div className="absolute top-4 right-4 p-2 bg-white/15 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transform scale-75 group-hover:scale-100 transition-all duration-300 delay-100">
                      <ZoomIn size={18} className="text-white" strokeWidth={1.5} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-20" data-testid="gallery-empty">
              <Images size={48} className="mx-auto text-slate-300 mb-4" strokeWidth={1} />
              <h3 className="font-['Barlow_Condensed'] font-bold text-xl text-slate-400">
                No photos in this category yet
              </h3>
              <p className="text-slate-400 mt-1 text-sm">Check back soon for updates</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-gradient-to-r from-[#0F172A] to-[#1E293B] relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(14,165,233,0.08)_0%,transparent_60%)]" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-['Barlow_Condensed'] font-bold text-3xl sm:text-4xl text-white mb-4">
            Want to See Our Operations First-Hand?
          </h2>
          <p className="text-slate-400 max-w-xl mx-auto mb-8">
            Schedule a visit to our facilities or contact us to learn more about how we handle your cargo with care.
          </p>
          <a
            href="/contact"
            className="btn-primary inline-block text-sm !py-3 !px-8"
            data-testid="gallery-cta-btn"
          >
            Contact Us Today
          </a>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxOpen && (
        <Lightbox
          images={filtered}
          currentIndex={lightboxIndex}
          onClose={closeLightbox}
          onPrev={prevImage}
          onNext={nextImage}
        />
      )}
    </div>
  );
}
